import { omit } from "underscore";
import { v4 as uuidv4 } from 'uuid'
import { $resourceRoutes } from "../resource/resourceRoutes.service";

export const $requestManager = function ($resultsStore, cfpLoadingBar, $timeout, $resourceManager) {
  var requestManager = {
    searches: {
      // STRUCTURE //
      // main: {
      //   searchId: 'ABCDEF',
      //   requestIds: {
      //     '12345' => {source: SOURCE, supplier: SUPPLIER, status: 'accepted'},
      //     '67890' => {source: SOURCE, supplier: SUPPLIER, status: ''},
      //   }
      // }
      // datamuse: {
      //  ...
      // }
    }
  };

  requestManager.addRequest = function (searchId, requestId, storeKey, source, supplier) {
    const entry = requestManager.searches[storeKey]
    if (entry.searchId === searchId) {
      // Ranking allows multiple imports for the same request ID, because we use list_id instead of a UUID so we don't need to
      // send the uuid on the huge round trip to the raning service. Once a request is accepted,
      // don't reset its status back to 'processing' on re-add, or results from earlier
      // keyword batches will be rejected.
      const existing = requestManager.searches[storeKey].requestIds[requestId];
      if (existing && existing.status === 'accepted') {
        return true;
      }
      requestManager.searches[storeKey].requestIds[requestId] = { source, supplier, status: 'processing' }
      return true;
    }
    return false;
  };

  // Register a request as already accepted (used for ranking when user returns with pending keywords from a previous session)
  requestManager.registerOutstandingRequest = function (requestId, storeKey, storeObject, source, supplier) {
    const searchId = requestManager.setup(storeKey, storeObject, false);
    if (requestManager.searches[storeKey].searchId === searchId) {
      const existing = requestManager.searches[storeKey].requestIds[requestId];
      if (existing && existing.status === 'accepted') {
        return searchId;
      }
      requestManager.searches[storeKey].requestIds[requestId] = { source, supplier, status: 'accepted' }
      return searchId;
    }
    return null;
  };

  requestManager.addResponse = function (requestId, storeKey) {
    const entry = requestManager.searches[storeKey].requestIds[requestId]
    if (entry) {
      entry.status = 'accepted'
      requestManager.searches[storeKey].requestIds[requestId] = entry;
      return true;
    }
    return false;
  };

  requestManager.otherRequestIds = function(requestId) {
    const { storeKey } = requestManager.getRequest(requestId);
    const otherRequests = omit(requestManager.searches[storeKey].requestIds, requestId)
    return Object.keys(otherRequests);
  }

  requestManager.updateLoadingBar = function(requestId) {
    const { storeKey } = requestManager.getRequest(requestId);
    if (storeKey === 'main' || storeKey === 'ranking') {
      if (requestManager.otherRequestIds(requestId).length > 0) {
        cfpLoadingBar.set(0.6);
      } else {
        cfpLoadingBar.set(1);
        $timeout(() => cfpLoadingBar.complete(), 50);
      }
    }
  }

  requestManager.deleteRequest = function (requestId) {
    requestManager.updateLoadingBar(requestId);
    return Object.entries(requestManager.searches).reduce((result, [storeKey, value]) => {
      if (value.requestIds.hasOwnProperty(requestId)) delete value.requestIds[requestId];
      result[storeKey] = {
        ...value.searchId,
        requestIds: value.requestIds
      }
      return result;
    }, {})
  };

  requestManager.clearSearch = function (storeKey) {
    delete requestManager.searches[storeKey];
  };

  requestManager.setup = function (storeKey, storeObject, shouldClear) {
    const existing = requestManager.searches[storeKey];
    if (existing && !shouldClear) return existing.searchId;
    $resultsStore[storeKey] = storeObject;
    const searchId = uuidv4();
    requestManager.searches[storeKey] = { searchId, requestIds: {} }
    return searchId;
  };

  requestManager.getRequest = requestId => {
    return Object.entries(requestManager.searches).reduce((result, [storeKey, value]) => {
      if (value.requestIds.hasOwnProperty(requestId)) result = { storeKey, ...value.requestIds[requestId] };
      return result;
    }, null)
  }
  
  requestManager.fail = function (requestId) {
    const { storeKey, supplier } = requestManager.getRequest(requestId)
    if ($resultsStore[storeKey] && supplier != 'gsc') {
      $resultsStore[storeKey].fail();
    }
  };
  
  requestManager.addData = function (requestId, data) {
    const { storeKey } = requestManager.getRequest(requestId)
    if ($resultsStore[storeKey]) {
      $resultsStore[storeKey].addFromCable(data);
      if (storeKey === 'ranking' && data.has_more) {
        const pendingKeywords = $resultsStore[storeKey].getPending().length;
        if (pendingKeywords === 0) {
          data.has_more = false;
        }
      }
    //   let p;
    //   if (storeKey === 'main' && parseInt(data.start) === 1) {
    //     performance.mark('mainResultsReturned');
    //     performance.measure('main', 'searchStart', 'mainResultsReturned');
    //     p = performance.getEntriesByName("main", "measure");
    //   }
    //   if (storeKey === 'datamuse') {
    //     performance.mark('lateralResultsReturned');
    //     performance.measure('lateral', 'searchStart', 'lateralResultsReturned');
    //     p = performance.getEntriesByName("lateral", "measure");
    //   }
    //   for (var i=0; i < p.length; i++) {
    //     // console.log (`${p[i].name}: ${parseFloat(p[i].duration/1000).toFixed(1)}s`) 
    //     // window.dataLayer = window.dataLayer || [];
    //     const params = {
    //       'search_type': p[i].name,
    //       'time': p[i].duration,
    //     }
    //     if (p[i].name === 'mainResultsReturned') {
    //       params.source = $resultsStore[storeKey].activeSeed.source;
    //     }
    //     $resourceManager.request('analytic_events', 'save', null, {analytic_event: params} )
    //   }
    }
  };

  return requestManager;
};

$requestManager.$inject = ['$resultsStore', 'cfpLoadingBar', '$timeout', '$resourceManager'];
